<div *ngIf="!mobile" class="top" [ngStyle]="{ color: secondaryColor, 'background-color': primaryColor }">
  <h1 [ngStyle]="{ color: secondaryColor }" [innerHtml]="data.area.name | safeHTML"></h1>
  <button disableRipple="true" mat-icon-button matTooltip="Close" mat-dialog-close>
    <mat-icon>clear</mat-icon>
  </button>
</div>
<div *ngIf="mobile" class="top">
  <button disableRipple="true" mat-icon-button matTooltip="Close" mat-dialog-close>
    <mat-icon>west</mat-icon>
  </button>
  <h1 [ngStyle]="{ color: secondaryColor }" [innerHtml]="data.area.name | safeHTML"></h1>
</div>
<div class="area">
  <span class="html-tag" [innerHtml]="htmlField | safeHTML"></span>
</div>
